import { useForm } from "react-hook-form";
import { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../../services/authService";
import styles from "./Forgot.module.css";
export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const login = location.state?.login;
const {
  register,
  handleSubmit,
  getValues,
  formState: { errors },
} = useForm({
  defaultValues: {
    login: login || "",
  },
});
const onSubmit = async (data) => {
  setLoading(true);
  try {
    await authService.resetPassword(data);
    toast.success("Password reset successfully");
    navigate("/login");
  } catch (err) {
    toast.error(
      err?.response?.data?.message || "Password reset failed"
    );
  } finally {
    setLoading(false);
  }
};
  return (
    <div className={styles.authWrapper}>
      <div className={styles.card}>
        {/* LOGO */}
        <div className={styles.logo}>
          <Link to="/" className="app-brand-link gap-2">
            {/* <img src="VITAURA" alt="Logo" /> */}
              {/* <h2 style={{color:"#FB6C22",textAlign:"center"}}>VITAURA</h2> */} 
              <img
  src="vitauralogo.jpg"
  alt="Vitaura Logo"
  style={{
    width: "220px",
    height: "80px",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  }}
/>
          </Link>
        </div>
        <h4 className={styles.title}>Reset Password 🔁</h4>
        <form onSubmit={handleSubmit(onSubmit)}>
          <input type="hidden" {...register("login")} />
          <div className={styles.formGroup}>
            <label>OTP</label>
            <input
              type="text"
              {...register("otp", { required: "OTP is required" })}
            />
            {errors.otp && (
              <span className={styles.error}>
                {errors.otp.message}
              </span>
            )}
          </div>
          <div className={styles.formGroup}>
            <label>New Password</label>
            <div style={{ position: "relative" }}>
             <input
  type={showPassword ? "text" : "password"}
  {...register("password", {
    required: "Password is required",
    minLength: {
      value: 8,
      message: "Password must be at least 8 characters",
    },
  })} 
     style={{ width: "100%", paddingRight: "40px" }}
/>

{errors.password && (
  <span className={styles.error}>
    {errors.password.message}
  </span>
)}
              <span
                onClick={() => setShowPassword(prev => !prev)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer"
                }}
              >
                <i className={showPassword ? "bx bx-show" : "bx bx-hide"} />
              </span>
            </div>
          </div>
          <div className={styles.formGroup}>
            <label>Confirm Password</label>
            <div style={{ position: "relative" }}>
              <input
                type={showConfirmPassword ? "text" : "password"}
               {...register("password_confirmation", {
  required: "Confirm your password",
  validate: (value) =>
    value === getValues("password") || "Passwords do not match",
})}
                style={{ width: "100%", paddingRight: "40px" }}
              />
              <span
                onClick={() => setShowConfirmPassword(prev => !prev)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer"
                }}
              >
                <i className={showConfirmPassword ? "bx bx-show" : "bx bx-hide"} />
              </span>
            </div>
          </div>
        <button type="submit" className={styles.primaryBtn} disabled={loading}>
  {loading ? "Resetting..." : "Reset Password"}
</button>
        </form>
      </div>
    </div>
  );
}